<template>
    <UserPageLayout>
        <div>
            <div style="margin-bottom: 2rem">
                <h1 class="system-text-color text-center text-3xl">{{ $t('title_invoice') }}</h1>
                <!-- <p class="text-xl text-center system-text-color">{{ plan.name }}</p> -->
                <p class="text-xl text-center system-text-color">{{ plan.description }}</p>
                <p class="text-xl font-bold text-center system-text-color py-4">
                    {{ $t('invoice_subscription_id') }}:
                    <span class="font-normal text-sm md:text-xl">{{ subscriptionId }}</span>
                </p>
            </div>

            <div class="max-w-xl m-auto">
                <div class="invoice-list">
                    <div class="invoice-row-head hidden md:block">
                        <div class="invoice-row text-dark-charcoal system-border mb-2">
                            <div class="invoice-column font-bold">{{ $t('invoice_table_invoice_id') }}</div>
                            <div class="amount-column font-bold">{{ $t('invoice_table_amount') }}</div>
                            <div class="created-column font-bold">{{ $t('invoice_table_created') }}</div>
                            <div class="download-column font-bold">{{ $t('invoice_table_download') }}</div>
                        </div>
                    </div>
                    <div
                        v-for="(invoice, index) in invoices"
                        :key="index"
                        class="invoice-row text-dark-charcoal system-border flex mb-2"
                    >
                        <div class="invoice-column truncate">
                            <span class="inline md:hidden font-bold shadow-text-none">
                                {{ $t('invoice_table_invoice_id') }}:
                            </span>
                            <span class="text-sm md:text-base shadow-text-none">{{ invoice.invoice_number }}</span>
                        </div>
                        <div class="amount-column">
                            <span class="inline md:hidden font-bold shadow-text-none">
                                {{ $t('invoice_table_amount') }}:
                            </span>
                            <span class="font-bold shadow-text-none">
                                <template v-if="plan.currency && plan.currency === 'NOK'">
                                    {{ moneyNokFormat(plan.nok_amount) }}
                                </template>
                                <template v-else>
                                    {{ moneyUsdFormat(plan.amount) }}
                                </template>
                            </span>
                        </div>
                        <div class="created-column">
                            <span class="inline md:hidden font-bold shadow-text-none">
                                {{ $t('invoice_table_created') }}:
                            </span>
                            <div class="flex ml-2">
                                <span class="mr-1 shadow-text-none">{{ invoice.start_data }}</span>
                                <Popper :options="{ placement: 'top' }">
                                    <div class="popper">
                                        <span
                                            >{{ $t('invoice_server_time') }}:
                                            {{ getLocalTime(parseInt(invoice.created_at.$date.$numberLong)) }}</span
                                        >
                                    </div>
                                    <div slot="reference">
                                        <i class="fas fa-info-circle shadow-text-none"></i>
                                    </div>
                                </Popper>
                            </div>
                        </div>
                        <div class="download-column">
                            <span class="inline md:hidden font-bold shadow-text-none">
                                {{ $t('invoice_table_download') }}:
                            </span>
                            <button
                                @click="downloadInvoice(invoice.invoice_path)"
                                class="btn system-button-color system-button-text-color text-sm font-opensans ml-2"
                            >
                                {{ $t('invoice_download_pdf_button') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </UserPageLayout>
</template>

<script>
import Request from '@/lib/request'
import UserService from '@/lib/user'
import helperMixins from '@/mixins/helper.js'
import appConfig from '@/app.config'
import UserPageLayout from '@/layouts/UserPage'
import Popper from 'vue-popperjs'

export default {
    name: 'Invoice',

    metaInfo() {
        return {
            title: this.$t('title_invoice')
        }
    },

    components: {
        UserPageLayout,
        Popper
    },

    mixins: [helperMixins],

    data() {
        return {
            subscriptionId: '',
            invoices: [],
            plan: {}
        }
    },

    mounted() {
        this.$store.commit('toggleMainLoader', false)

        this.$nextTick(() => {
            this.fetchInvoice(this.$route.params.id)
        })
    },

    methods: {
        createRequest() {
            const userService = new UserService()
            const token = userService.getToken()

            return new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
        },

        getLocalTime(d) {
            const date = new Date(d)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

            return formattedDate
        },

        fetchInvoice(id) {
            const request = this.createRequest()
            this.$store.commit('toggleMainLoader', true)

            request
                .get(appConfig.api.getInvoice.replace(/__id__/, id))
                .then(res => {
                    const data = res.data.data
                    const dataInvoices = data.invoices

                    this.subscriptionId = data.order_invoice_id

                    if (typeof dataInvoices == 'undefined') {
                        return this.$router.push({ name: 'order' })
                    }

                    this.invoices = dataInvoices
                    this.plan = data.plan
                    this.$store.commit('toggleMainLoader', false)
                })
                .catch(() => {
                    this.$store.commit('toggleMainLoader', false)
                    this.$router.push({ name: 'order' })
                })
        },

        downloadInvoice(path) {
            const baseUrl = process.env.VUE_APP_ROOT_URL
            return window.open(`${baseUrl}${path}`, '_blank')
        }
    }
}
</script>


<style lang="scss" scoped>
.invoice-list {
    padding: 0.5rem;
    border-radius: 5px;
    margin-bottom: 1.5rem;

    .invoice-row {
        background-color: #fff;
        padding: 1rem;
        border-radius: 5px;
        display: flex;

        .invoice-column {
            width: 30%;
        }

        .amount-column {
            width: 16%;
        }

        .created-column {
            width: 24%;
        }

        .download-column {
            width: 30%;
            text-align: center;
        }
    }

    @media screen and (max-width: 767px) {
        .invoice-row {
            flex-direction: column;
            .invoice-column {
                width: 100%;
                padding: 5px;
            }

            .amount-column {
                width: 100%;
                padding: 5px;
            }

            .created-column {
                display: flex;
                width: 100%;
                padding: 5px;
            }

            .download-column {
                width: 100%;
                text-align: left;
                padding: 5px;
            }
        }
    }
}
</style>
